var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "bg-grey-1" },
    [
      _vm.podcast.type == "podcast"
        ? _c("q-card-media", [
            _c("div", { staticClass: "container" }, [
              _vm.podcast.image_large
                ? _c("img", {
                    staticClass: "thumb image",
                    attrs: { src: _vm.podcast.image_large }
                  })
                : _vm._e(),
              !_vm.podcast.image_large
                ? _c("img", {
                    staticClass: "thumb image",
                    attrs: { src: _vm.getPlaceholder }
                  })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "middle" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      icon: "fal fa-play",
                      size: "1.5rem"
                    },
                    on: { click: _vm.playPlaylist }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _c(
        "q-card-main",
        { staticClass: "relative-position" },
        [
          _c("div", { staticClass: "line-card bg-primary absolute-top" }),
          _vm.podcast.type == "podcast"
            ? _c("div", { staticClass: "row q-my-sm" }, [
                _c("div", { staticClass: "col-10" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 q-title text-weight-medium" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.podcast.title) +
                            "\n                    "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 q-mb-md" },
                      [
                        _c("q-rating", {
                          attrs: {
                            slot: "subtitle",
                            color: "amber",
                            icon: "fas fa-star",
                            max: 5,
                            readonly: ""
                          },
                          slot: "subtitle",
                          model: {
                            value: _vm.podcast.avg_stars,
                            callback: function($$v) {
                              _vm.$set(_vm.podcast, "avg_stars", $$v)
                            },
                            expression: "podcast.avg_stars"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c(
                      "vc-donut",
                      {
                        attrs: {
                          sections: _vm.setSections,
                          size: 100,
                          unit: "%"
                        }
                      },
                      [
                        _c("h6", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.getPercentage(_vm.podcast.user_progress)
                              ) +
                              "%\n                    "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _vm.podcast.areas.length > 0
                          ? _c("p", { staticClass: "caption" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("areas")) +
                                  "\n                            "
                              )
                            ])
                          : _vm._e(),
                        _vm.podcast.areas.length > 0
                          ? _c(
                              "p",
                              { staticClass: "tooltip q-mb-sm" },
                              _vm._l(_vm.podcast.areas, function(area, index) {
                                return _c("span", { key: index }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.getArea(area))
                                  ),
                                  _vm.podcast.areas.length - 1 > index
                                    ? _c("span", [_vm._v(", ")])
                                    : _vm._e()
                                ])
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm.podcast.user_groups.length > 0
                          ? _c("p", { staticClass: "caption" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("groups")) +
                                  "\n                            "
                              )
                            ])
                          : _vm._e(),
                        _vm.podcast.user_groups.length > 0
                          ? _c(
                              "p",
                              { staticClass: "tooltip q-mb-sm" },
                              _vm._l(_vm.podcast.user_groups, function(
                                group,
                                index
                              ) {
                                return _c("span", { key: index }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.getGroup(group))
                                  ),
                                  _vm.podcast.user_groups.length - 1 > index
                                    ? _c("span", [_vm._v(", ")])
                                    : _vm._e()
                                ])
                              }),
                              0
                            )
                          : _vm._e()
                      ]),
                      _c("div", { staticClass: "col-6 " }, [
                        _vm.podcast.tags.length > 0
                          ? _c("p", { staticClass: "caption" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("tags")) +
                                  "\n                            "
                              )
                            ])
                          : _vm._e(),
                        _c(
                          "p",
                          { staticClass: "tooltip q-mb-sm" },
                          _vm._l(_vm.podcast.tags, function(tag, index) {
                            return _c("span", { key: index }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.getTag(tag))
                              ),
                              _vm.podcast.tags.length - 1 > index
                                ? _c("span", [_vm._v(", ")])
                                : _vm._e()
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _vm.podcast.type == "user_podcast"
            ? _c("div", { staticClass: "row q-my-sm" }, [
                _c("div", { staticClass: "col-7" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 q-title text-weight-medium" },
                      [
                        _vm.podcast.type == "user_podcast"
                          ? _c("q-btn", {
                              attrs: {
                                flat: "",
                                round: "",
                                icon: "fal fa-play"
                              },
                              on: { click: _vm.playPlaylist }
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.podcast.title) +
                            "\n                    "
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "col-5 text-right" },
                  [
                    _c("q-btn", {
                      attrs: {
                        flat: "",
                        round: "",
                        color: "primary",
                        icon: "far fa-pencil-alt"
                      },
                      on: {
                        click: function($event) {
                          return _vm.clickAddPlaylist()
                        }
                      }
                    }),
                    _c("q-btn", {
                      attrs: {
                        flat: "",
                        round: "",
                        color: "negative",
                        icon: "far fa-trash-alt"
                      },
                      on: {
                        click: function($event) {
                          return _vm.confirmRemove("remove_playlist")
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.podcast.type == "podcast" && _vm.actions.length > 0
            ? _c("q-card-actions", [
                _c(
                  "p",
                  { staticClass: "text-center fit" },
                  _vm._l(_vm.actions, function(action, index) {
                    return _c(
                      "q-btn",
                      {
                        key: index,
                        attrs: {
                          flat: "",
                          icon: action.icon,
                          label: _vm.getLabel(action.label),
                          color: _vm.getColor(action.slug)
                        },
                        on: {
                          click: function($event) {
                            return _vm.doAction(action.slug)
                          }
                        }
                      },
                      [
                        _c("q-tooltip", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t(action.tooltip)) +
                              "\n                    "
                          )
                        ])
                      ],
                      1
                    )
                  }),
                  1
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _c("q-card-separator"),
      _c(
        "q-card-actions",
        [
          _c(
            "q-list",
            { staticClass: "full-width", attrs: { "no-border": "" } },
            [
              _c(
                "q-collapsible",
                {
                  attrs: {
                    icon: "fal fa-album-collection",
                    label:
                      _vm.podcast.podcast_playlist_audio.length +
                      " " +
                      _vm.$t("audios")
                  }
                },
                [
                  _c(
                    "q-list",
                    {
                      staticClass: "full-width",
                      attrs: { dense: "", separator: "" }
                    },
                    _vm._l(_vm.podcast.podcast_playlist_audio, function(
                      audio,
                      index
                    ) {
                      return _c(
                        "q-item",
                        {
                          key: index,
                          class: _vm.getClassline(audio),
                          style: _vm.cursor,
                          nativeOn: {
                            click: function($event) {
                              return _vm.addUserPlaylist(audio)
                            }
                          }
                        },
                        [
                          _c(
                            "q-item-side",
                            [
                              _c(
                                "q-item-tile",
                                [
                                  _c("q-btn", {
                                    attrs: {
                                      flat: "",
                                      round: "",
                                      icon: "fal fa-play"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.playAudio(audio)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("q-item-main", { attrs: { label: audio.title } }),
                          _vm.podcast.type == "podcast"
                            ? _c(
                                "q-item-side",
                                { attrs: { right: "" } },
                                [
                                  audio.progress_audio_listen_status == 2
                                    ? _c("q-icon", {
                                        attrs: {
                                          name: "fal fa-check-circle",
                                          size: "1.5rem",
                                          color: "positive"
                                        }
                                      })
                                    : _c("q-icon", {
                                        attrs: {
                                          name: "fal fa-circle",
                                          size: "1.5rem",
                                          color: "primary"
                                        }
                                      })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.podcast.type == "user_podcast"
                            ? _c(
                                "q-item-side",
                                { attrs: { right: "" } },
                                [
                                  _c("q-btn", {
                                    attrs: {
                                      flat: "",
                                      round: "",
                                      color: "negative",
                                      icon: "far fa-trash-alt"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.confirmRemove(
                                          "remove_music",
                                          index
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("add-playlist", {
        attrs: { show: _vm.show_modal_add_plalist, podcast: _vm.podcast },
        on: { hideModalPlayList: _vm.hideModalPlayList }
      }),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _vm.type_remove == "remove_playlist"
                    ? _c("q-btn", {
                        attrs: { color: "negative", label: _vm.$t("remove") },
                        on: {
                          click: function($event) {
                            return _vm.deletePlayList()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.type_remove == "remove_music"
                    ? _c("q-btn", {
                        attrs: { color: "negative", label: _vm.$t("remove") },
                        on: {
                          click: function($event) {
                            return _vm.deleteMusic()
                          }
                        }
                      })
                    : _vm._e()
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }